import { Phone, CalendarPlus, Wrench, Plus } from 'lucide-react';
import type { NavigatorLine } from './crmNavigatorLine';
import { crmTelHref } from './crmPhone';
import { salesStageUsesOpsMacro } from './crmDealStagePresets';
import type { SalesStage } from '../../../api';

type Props = {
  navigator: NavigatorLine | null;
  stage: SalesStage;
  phone?: string | null;
  productionRead: boolean;
  hasOpenTask: boolean;
  nextOpenTaskKind?: string | null;
  onPlanCall: () => void;
  onOpenOps: () => void;
  onAfterCallClick?: () => void;
  hapticSelection: () => void;
};

export function CrmDealNextActionBar({
  navigator,
  stage,
  phone,
  productionRead,
  hasOpenTask,
  nextOpenTaskKind,
  onPlanCall,
  onOpenOps,
  onAfterCallClick,
  hapticSelection,
}: Props) {
  const telHref = crmTelHref(phone);
  const opsFocus = salesStageUsesOpsMacro(stage) || productionRead;

  let label = 'Запланировать звонок';
  let action: 'plan' | 'call' | 'ops' = 'plan';
  let icon = <CalendarPlus size={18} />;

  if (!hasOpenTask) {
    label = 'Запланировать действие';
    action = 'plan';
    icon = <Plus size={18} />;
  } else if (nextOpenTaskKind === 'call' && telHref) {
    label = 'Позвонить клиенту';
    action = 'call';
    icon = <Phone size={18} />;
  } else if (navigator?.tone === 'critical') {
    label = 'Запланировать следующий шаг';
    action = 'plan';
    icon = <Plus size={18} />;
  } else if (telHref && navigator?.tone !== 'ops' && nextOpenTaskKind !== 'call') {
    label = 'Позвонить клиенту';
    action = 'call';
    icon = <Phone size={18} />;
  } else if (opsFocus) {
    label = 'Операции и производство';
    action = 'ops';
    icon = <Wrench size={18} />;
  }

  const btnStyle = {
    background: action === 'call' ? 'rgba(72,187,120,0.22)' : 'rgba(99,179,237,0.22)',
    color: action === 'call' ? '#68D391' : '#63B3ED',
    border: '1px solid rgba(255,255,255,0.12)',
  };

  if (action === 'call' && telHref) {
    return (
      <div className="shrink-0 px-4 py-3 border-t" style={{ borderColor: 'var(--border-subtle)', background: 'rgba(10,25,47,0.95)' }}>
        <a
          href={telHref}
          onClick={() => {
            hapticSelection();
            onAfterCallClick?.();
          }}
          className="btn-glow w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl font-bold text-sm touch-manipulation min-h-[52px]"
          style={btnStyle}
        >
          {icon}
          {label}
        </a>
      </div>
    );
  }

  return (
    <div className="shrink-0 px-4 py-3 border-t" style={{ borderColor: 'var(--border-subtle)', background: 'rgba(10,25,47,0.95)' }}>
      <button
        type="button"
        onClick={() => {
          hapticSelection();
          if (action === 'ops') onOpenOps();
          else onPlanCall();
        }}
        className="btn-glow w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl font-bold text-sm touch-manipulation min-h-[52px]"
        style={btnStyle}
      >
        {icon}
        {label}
      </button>
    </div>
  );
}
